"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeProvider = exports.CompositeContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.CompositeContext = (0, react_1.createContext)({
    appId: '',
    platform: 'mobile',
});
/**
 * Провайдер настроек всей ui библиотеки, для переопределения параметров компонентов
 * Компонент опционален, в случае необходимости каких либо глобальных настроек
 */
const CompositeProvider = ({ children, config }) => ((0, jsx_runtime_1.jsx)(exports.CompositeContext.Provider, { value: config, children: children }));
exports.CompositeProvider = CompositeProvider;
